/**
 * @generated SignedSource<<59055ae2f9f0e7dc7d7103fdb1cc1fa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentItemRenderContent$data = {
  readonly __typename: "Video";
  readonly " $fragmentSpreads": FragmentRefs<"cardContentItemContent" | "contentActionBarContent" | "contentAuthorLinkContent" | "contentCoverImageContent" | "contentHeadlineContent" | "contentLiveTagContent" | "contentPrintHeadlineContent" | "contentPublishedDateContent" | "contentSubHeadlineContent" | "contentSummaryContent" | "contentTopicLinkContent" | "entityLink" | "hooksUseContentSponsorContent" | "magazinesStyleCardContentItemContent" | "magazinesStyleLeadContentItemContent" | "morningStudioContentItemContent" | "opinionContentItemContent" | "postiesPrimaryContentItemContent" | "postiesSecondaryContentItemContent" | "postiesSectionPrimaryContentItemContent" | "postiesSectionSecondaryContentItemContent" | "primaryContentItemContent" | "searchContentItemContent" | "secondaryContentItemContent" | "videoDurationOverlayVideo">;
  readonly " $fragmentType": "contentItemRenderContent";
};
export type contentItemRenderContent$key = {
  readonly " $data"?: contentItemRenderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentItemRenderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentActionBarContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentPublishedDateContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSubHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSummaryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentPrintHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentTopicLinkContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveTagContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentAuthorLinkContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "primaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "secondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "searchContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "opinionContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "cardContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "morningStudioContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "magazinesStyleLeadContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "magazinesStyleCardContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseContentSponsorContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesSectionPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesSectionSecondaryContentItemContent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "videoDurationOverlayVideo"
        }
      ],
      "type": "Video",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "79f07ff6b400432915216dae825193cd";

export default node;
